<div class="focal-area-sidebar">
	<!-- Header with Add Button (just plus icon) -->
	<div class="sidebar-header">
		<h3>Focal Areas</h3>
		<div class="header-actions">
			<button
				*ngIf="uniqueTags.length > 0"
				class="icon-btn filter-button"
				type="button"
				matTooltip="Filter focal areas by tag"
				[matMenuTriggerFor]="tagFilterMenu">
				<mat-icon>filter_list</mat-icon>
			</button>
			<button class="icon-btn add-button" type="button" (click)="onAddClick()" matTooltip="Add focal area">
				<mat-icon>add</mat-icon>
			</button>
		</div>
	</div>

	<mat-menu #tagFilterMenu="matMenu" class="tiny tag-filter-menu">
		<button mat-menu-item (click)="onClearTagFilters()" [disabled]="tagFilterSelections.size === 0">
			<mat-icon>clear_all</mat-icon>
			<span>All</span>
		</button>
		<button
			mat-menu-item
			*ngFor="let tag of uniqueTags"
			(click)="onToggleFilterTag(tag)"
			[class.selected]="tagFilterSelections.has(tag)">
			<mat-icon>{{ tagFilterSelections.has(tag) ? 'check_box' : 'check_box_outline_blank' }}</mat-icon>
			<span>{{ tag }}</span>
		</button>
	</mat-menu>

	<!-- Focal Areas List -->
	<div class="focal-areas-list">
		<div *ngFor="let focalArea of focalAreas; let i = index"
			 class="focal-area-item"
			 [class.dirty]="isDirty(i)"
			 [class.selected]="isSelected(i)"
			 [class.expanded]="isSelected(i)">

			<!-- Compact Header (always visible) -->
			<div class="item-header" (click)="onSelectClick(i)">
				<span class="item-name">
					<div class="row">
						<!-- Show input when editing, otherwise show text -->
						<input *ngIf="isEditingName(i)"
							#nameInput
							type="text"
							class="name-edit-input"
							[(ngModel)]="tempName"
							(blur)="onNameInputBlur()"
							(keydown)="onNameInputKeydown($event, i)"
							(click)="$event.stopPropagation()"
							(mousedown)="$event.stopPropagation()">
						<span *ngIf="!isEditingName(i)" (dblclick)="onStartEditingName(i, $event)">
							{{ focalArea.name }}
						</span>
						<mat-icon *ngIf="focalArea.isDefault" class="default-star" inline>star</mat-icon>
					</div>

					<div class="item-tags" *ngIf="focalArea.tags?.length">
						<span class="tag-pill" *ngFor="let tag of focalArea.tags">{{ tag }}</span>
					</div>
				</span>
				<div class="item-actions">
					<button mat-icon-button [matMenuTriggerFor]="contextMenu" (click)="$event.stopPropagation()">
						<mat-icon>more_horiz</mat-icon>
					</button>
				</div>

				<!-- Context Menu -->
				<mat-menu #contextMenu="matMenu" class="tiny">
					<button mat-menu-item (click)="onStartEditingName(i, $event)">
						<mat-icon>edit</mat-icon>
						<span>Rename</span>
					</button>
					<button mat-menu-item (click)="onCopyCropData(i)">
						<mat-icon>content_copy</mat-icon>
						<span>Copy</span>
					</button>
					<button mat-menu-item (click)="onSetDefault(i)" *ngIf="!focalArea.isDefault">
						<mat-icon>star</mat-icon>
						<span>Set as Default</span>
					</button>
					<button mat-menu-item (click)="onDeleteClick(i)">
						<mat-icon>delete</mat-icon>
						<span>Remove</span>
					</button>
				</mat-menu>
			</div>

			<!-- Expanded Details (only visible when selected) -->
			<div class="item-details" *ngIf="isSelected(i)">
				<!-- Bounding Box Coordinates (compact info grid) -->
				<div class="coordinates-info">
					<!-- X Coordinate -->
					<div class="coordinate-item">
						<span class="coordinate-label">X:</span>
						<!-- Display mode -->
						<span *ngIf="!isEditingCoordinate(i, 'x')" class="coordinate-value coordinate-display">
							{{ focalArea.boundingBox.x | number:'1.0-0' }}%
							<button class="icon-btn edit-coordinate-btn"
									(click)="onStartEditingCoordinate(i, 'x', $event)"
									matTooltip="Edit X">
								<mat-icon>edit</mat-icon>
							</button>
						</span>
						<!-- Edit mode -->
						<span *ngIf="isEditingCoordinate(i, 'x')" class="coordinate-value coordinate-edit">
							<input type="number"
								   class="coordinate-input"
								   [(ngModel)]="tempCoordinate"
								   (keydown)="onCoordinateInputKeydown($event, i)"
								   placeholder="0">
							<button class="icon-btn save-coordinate-btn"
									(click)="onSaveCoordinate(i)"
									matTooltip="Save">
								<mat-icon>check</mat-icon>
							</button>
							<button class="icon-btn cancel-coordinate-btn"
									(click)="onCancelEditingCoordinate()"
									matTooltip="Cancel">
								<mat-icon>close</mat-icon>
							</button>
						</span>
					</div>

					<!-- Y Coordinate -->
					<div class="coordinate-item">
						<span class="coordinate-label">Y:</span>
						<!-- Display mode -->
						<span *ngIf="!isEditingCoordinate(i, 'y')" class="coordinate-value coordinate-display">
							{{ focalArea.boundingBox.y | number:'1.0-0' }}%
							<button class="icon-btn edit-coordinate-btn"
									(click)="onStartEditingCoordinate(i, 'y', $event)"
									matTooltip="Edit Y">
								<mat-icon>edit</mat-icon>
							</button>
						</span>
						<!-- Edit mode -->
						<span *ngIf="isEditingCoordinate(i, 'y')" class="coordinate-value coordinate-edit">
							<input type="number"
								   class="coordinate-input"
								   [(ngModel)]="tempCoordinate"
								   (keydown)="onCoordinateInputKeydown($event, i)"
								   placeholder="0">
							<button class="icon-btn save-coordinate-btn"
									(click)="onSaveCoordinate(i)"
									matTooltip="Save">
								<mat-icon>check</mat-icon>
							</button>
							<button class="icon-btn cancel-coordinate-btn"
									(click)="onCancelEditingCoordinate()"
									matTooltip="Cancel">
								<mat-icon>close</mat-icon>
							</button>
						</span>
					</div>

					<!-- Width Coordinate -->
					<div class="coordinate-item">
						<span class="coordinate-label">W:</span>
						<!-- Display mode -->
						<span *ngIf="!isEditingCoordinate(i, 'width')" class="coordinate-value coordinate-display">
							{{ focalArea.boundingBox.width | number:'1.0-0' }}%
							<button class="icon-btn edit-coordinate-btn"
									(click)="onStartEditingCoordinate(i, 'width', $event)"
									matTooltip="Edit Width">
								<mat-icon>edit</mat-icon>
							</button>
						</span>
						<!-- Edit mode -->
						<span *ngIf="isEditingCoordinate(i, 'width')" class="coordinate-value coordinate-edit">
							<input type="number"
								   class="coordinate-input"
								   [(ngModel)]="tempCoordinate"
								   (keydown)="onCoordinateInputKeydown($event, i)"
								   placeholder="0">
							<button class="icon-btn save-coordinate-btn"
									(click)="onSaveCoordinate(i)"
									matTooltip="Save">
								<mat-icon>check</mat-icon>
							</button>
							<button class="icon-btn cancel-coordinate-btn"
									(click)="onCancelEditingCoordinate()"
									matTooltip="Cancel">
								<mat-icon>close</mat-icon>
							</button>
						</span>
					</div>

					<!-- Height Coordinate -->
					<div class="coordinate-item">
						<span class="coordinate-label">H:</span>
						<!-- Display mode -->
						<span *ngIf="!isEditingCoordinate(i, 'height')" class="coordinate-value coordinate-display">
							{{ focalArea.boundingBox.height | number:'1.0-0' }}%
							<button class="icon-btn edit-coordinate-btn"
									(click)="onStartEditingCoordinate(i, 'height', $event)"
									matTooltip="Edit Height">
								<mat-icon>edit</mat-icon>
							</button>
						</span>
						<!-- Edit mode -->
						<span *ngIf="isEditingCoordinate(i, 'height')" class="coordinate-value coordinate-edit">
							<input type="number"
								   class="coordinate-input"
								   [(ngModel)]="tempCoordinate"
								   (keydown)="onCoordinateInputKeydown($event, i)"
								   placeholder="0">
							<button class="icon-btn save-coordinate-btn"
									(click)="onSaveCoordinate(i)"
									matTooltip="Save">
								<mat-icon>check</mat-icon>
							</button>
							<button class="icon-btn cancel-coordinate-btn"
									(click)="onCancelEditingCoordinate()"
									matTooltip="Cancel">
								<mat-icon>close</mat-icon>
							</button>
						</span>
					</div>
					<div class="coordinate-item crop-mode-ar-row">
						<div class="aspect-ratio-item">
							<span class="coordinate-label">AR:</span>

						<!-- Display mode -->
						<span *ngIf="!isEditingAspectRatio(i)" class="coordinate-value aspect-ratio-display">
							{{ focalArea.aspectRatio || '1:1' }}
							<button class="icon-btn edit-aspect-ratio-btn"
									(click)="onStartEditingAspectRatio(i, $event)"
									matTooltip="Edit aspect ratio">
								<mat-icon>edit</mat-icon>
							</button>
							<button class="icon-btn reset-aspect-ratio-btn"
									*ngIf="isAspectRatioDirty && isAspectRatioDirty(i)"
									(click)="onResetAspectRatioClick(i, $event)"
									matTooltip="Reset to auto-calculate">
								<mat-icon>refresh</mat-icon>
							</button>
						</span>

						<!-- Edit mode -->
						<span *ngIf="isEditingAspectRatio(i)" class="coordinate-value aspect-ratio-edit">
							<input type="text"
								   class="aspect-ratio-input"
								   [(ngModel)]="tempAspectRatio"
								   (keydown)="onAspectRatioInputKeydown($event, i)"
								   placeholder="16:9"
								   #aspectRatioInput>
							<button class="icon-btn save-aspect-ratio-btn"
									(click)="onSaveAspectRatio(i)"
									matTooltip="Save">
								<mat-icon>check</mat-icon>
							</button>
							<button class="icon-btn cancel-aspect-ratio-btn"
									(click)="onCancelEditingAspectRatio()"
									matTooltip="Cancel">
								<mat-icon>close</mat-icon>
							</button>
						</span>
						</div>
						<div class="crop-mode-item"
							 (click)="onToggleCropMode(i, $event)"
							 [matTooltip]="'Click to toggle: ' + (focalArea.cropMode === 'contain' ? 'Switch to Cover' : 'Switch to Contain')">
							<mat-icon class="crop-mode-icon">{{ focalArea.cropMode === 'contain' ? 'fit_screen' : 'crop_free' }}</mat-icon>
							<span class="coordinate-value crop-mode-value">{{ focalArea.cropMode === 'contain' ? 'Contain' : 'Cover' }}</span>
					</div>
				</div>
			</div>

			<div class="tags-editor">
					<div class="tags-display" *ngIf="!isEditingTags(i)">
						<div class="flex">
							<div class="left">
								<span class="tags-label">Tags</span>
							</div>
							<div class="right">
								<button
									class="icon-btn edit-tags-btn"
									type="button"
									(click)="onStartEditingTags(i, $event)"
									matTooltip="Edit tags">
									<mat-icon>edit</mat-icon>
								</button>
							</div>
						</div>

						<div class="tags-chip-strip" *ngIf="focalArea.tags?.length" (click)="$event.stopPropagation()">
							<span class="tag-chip" *ngFor="let tag of focalArea.tags">{{ tag }}</span>
						</div>

					</div>
					<div class="tags-edit" *ngIf="isEditingTags(i)" (click)="$event.stopPropagation()">
						<div class="tags-chip-strip tags-chip-strip--editable">
							<span class="tag-chip tag-chip--editable" *ngFor="let tag of tempTags; let tagIndex = index">
								{{ tag }}
								<button class="icon-btn chip-remove-btn" type="button" (click)="onRemoveTempTag(tagIndex)" matTooltip="Remove tag">
									<mat-icon>close</mat-icon>
								</button>
							</span>
						</div>
						<div class="tag-input-row">
							<input
								type="text"
								class="tag-input"
								placeholder="Add tag"
								[(ngModel)]="tagInputValue"
								(ngModelChange)="onTagInputValueChange($event)"
								(keydown)="onTagInputKeydown($event, i)">
							<button class="icon-btn add-tag-btn" type="button" (click)="onAddTagClick(i, $event)" [disabled]="!tagInputValue?.trim()">
								<mat-icon>add</mat-icon>
							</button>
						</div>
						<div class="tag-error" *ngIf="tagEditError">{{ tagEditError }}</div>
						<div class="tag-action-row mt-2">
							<button class="tag-action-btn" type="button" (click)="onSaveTags(i, $event)">Save</button>
							<button class="tag-action-btn tag-action-btn--secondary" type="button" (click)="onCancelEditingTags($event)">Cancel</button>
						</div>
					</div>
				</div>

				<!-- Action Buttons -->
				<div class="action-buttons">
					<!-- Save Button (Always show) -->
					<button mat-raised-button color="primary" (click)="onSaveClick()" [disabled]="isSaving || !canSave" class="save-button">
						<mat-icon>cloud_upload</mat-icon>
						SAVE
					</button>

					<!-- Select Button (Select Mode Only) -->
					<button *ngIf="selectMode" mat-raised-button color="accent" (click)="onSelectFocalAreaClick(i)" class="select-button">
						SELECT
					</button>
				</div>
			</div>
		</div>

		<!-- Empty State -->
		<div *ngIf="focalAreas.length === 0" class="empty-state">
			<mat-icon>crop_free</mat-icon>
			<p>No focal areas yet</p>
			<p class="hint">Click the + button to create your first focal area</p>
		</div>
	</div>

	<!-- Editor Settings Section -->
	<div class="editor-settings">
		<h3>Editor Settings</h3>
		<div class="settings-actions">
			<button mat-button (click)="onCopyFocalAreasClick()" class="setting-button" matTooltip="Copy Focal Areas">
				<mat-icon>content_copy</mat-icon>
				COPY
			</button>
			<button mat-button (click)="onPasteFocalAreasClick()" class="setting-button" matTooltip="Paste Focal Areas">
				<mat-icon>content_paste</mat-icon>
				PASTE
			</button>
			<button *ngIf="shouldShowAutoGenerateButton" mat-button (click)="onAutoGenerateFocalAreasClick()" class="setting-button" matTooltip="Auto-Generate from Creative Units">
				<mat-icon>auto_fix_high</mat-icon>
				GENERATE FROM LAYOUTS
			</button>
			<button mat-button (click)="onReplaceImageClick()" class="setting-button">
				<mat-icon>image</mat-icon>
				REPLACE IMAGE
			</button>
		</div>
	</div>
</div>
